import { Card } from "@mui/material";
import styled from "styled-components";
import { DimensionsProps } from "./types";
import theme from "../../theme/theme";
import { Help as MuiHelp } from "@mui/icons-material";

export const CardContainer = styled.div<DimensionsProps>`
  font-family: "Inter", sans-serif;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  min-width: 200px;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  transition: box-shadow 0.3s ease;
  margin: 10px auto;

  padding: 0 10px;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    width: 97%;
  }

  @media (max-width: 400px) {
    padding: 0;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-radius: 10px;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const LeftContainer = styled.div`
  margin: auto 20px auto 10px;
  padding: 20px 0;
  order: 1;

  @media (max-width: 1024px) {
    margin: 20px auto 20px auto;
    order: 2;
  }

  @media (max-width: 767px) {
    width: 86%;
    height: auto;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 20px;
  width: 100%;
  order: 2;

  @media (max-width: 1024px) {
    order: 1;
    margin-bottom: 0;
    width: auto;
  }
`;

export const StarContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const ResourceName = styled.h1`
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 20px 0;

  @media (max-width: 1024px) {
    margin: 20px 0 25px 0;
  }
`;

export const DetailLabel = styled.p`
  font-size: 20px;
  font-weight: 600;
  color: #7b7a7a;
  margin: 0 0 5px 0;
`;

export const DetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;

export const ValueLabel = styled.p`
  font-size: 20px;
  font-weight: 400;
  color: #7b7a7a;
  margin: 0 0 5px 0;
`;

export const ReservationDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;

  @media (max-width: 1024px) {
    margin-bottom: 30px;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
  }
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const DateTimeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin: 0;
  width: 100%;

  @media (max-width: 1024px) {
    margin: 0 auto;
    gap: 30px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  justify-content: center;
`;

export const CustomHelpIcon = styled(MuiHelp)`
  color: ${theme.color.silver};
  transition: color 0.3s ease-in-out;

  &:hover {
    color: ${theme.color.stone};
    transition: color 0.3s ease-in-out;
    cursor: pointer;
  }
`;

export const HelpContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${CustomHelpIcon} {
    color: ${theme.color.stone};
    transition: color 0.3s ease-in-out;
  }
`;

export const HelpTrigger = styled.span`
  cursor: help;
  color: blue;
`;

export const HelpTooltip = styled.div`
  display: none;
  transition: display 0.5s ease;
  position: absolute;
  font-size: 14px;
  top: -70px;
  left: 35px;
  width: 400px;
  background-color: rgba(255, 255, 255, 0.6); /* Fondo blanco con opacidad */
  backdrop-filter: blur(15px); /* Efecto de desenfoque */
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  z-index: 100;

  @media (max-width: 400px) {
    top: -70px;
    left: -80px;
    width: 260px;
  }

  ${HelpContainer}:hover & {
    display: block;
    transition: display 0.5s ease;
  }

  p {
    margin: 0;
    line-height: 1.5;

    strong {
      font-weight: bold;
    }
  }
`;

export const HelpIcon = styled.div``;

export const CrossContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;
